import { useTranslation } from 'react-i18next'

import { Switch, Text } from '@reveni-io/reveni-ui'
import { Divider } from '@reveni-io/reveni-ui'

import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'
import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import * as Styles from './styles'

const RestockProductsConfiguration = ({ allowedPreferences, manageRestock, setManageRestock, disabled }) => {
  const { t } = useTranslation()
  const { hasPermission } = useUserPermissions()

  if (!allowedPreferences.includes(preferences.manageRestock)) return null

  return (
    <>
      <Divider />
      <Styles.RestockProductsContainer>
        <Text type="titleM">{t('Reposición de productos')}</Text>
        <Switch
          checked={manageRestock}
          onChange={e => setManageRestock(e.target.checked)}
          label={t('Reponer productos por defecto al aceptar su devolución')}
          disabled={disabled || !hasPermission(userPermissions.editLogistics)}
        />
      </Styles.RestockProductsContainer>
    </>
  )
}

export default RestockProductsConfiguration
